import { isString } from '../is-string/is-string';
import type { NumericString } from '@pct-ts/typing';

export function isNumeric(obj: unknown): obj is NumericString {
  if (!isString(obj)) {
    return false;
  }

  if (obj.trim() === '') {
    return false;
  }

  // Reject hexadecimal, binary, and octal notation
  if (/^0[xbo]/i.test(obj.trim())) {
    return false;
  }

  const num = Number(obj);
  return !isNaN(num) && isFinite(num);
}
